import { Button, Form, FormControl, Input, Modal, Schema, Alert } from 'rsuite';
import React from 'react';
import PropTypes from 'prop-types';

function GetFeedback({ show, setClose, handleSuccess }) {
  let reason = null;
  let formRef = null;

  const model = () => {
    return Schema.Model({
      reason: Schema.Types.StringType()
        .isRequired('This field is required')
        .maxLength(250, 'Max length is 250 characters.'),
    });
  };
  return (
    <Modal
      className="tenants-instruction-modal"
      show={show}
      backdrop="static"
      onHide={() => setClose(false)}
      size={'xs'}>
      <Modal.Header style={{ textAlign: 'center' }}>
        <Modal.Title>Send Feedback</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form ref={ref => (formRef = ref)} layout="horizontal" model={model()}>
          <FormControl
            style={{ resize: 'none' }}
            accepter={Input}
            Placeholder={'Your feedback...'}
            name="reason"
            rows={4}
            componentClass={'textarea'}
            onChange={val => {
              reason = val;
            }}
            size="sm"
          />
        </Form>
      </Modal.Body>
      <Modal.Footer style={{ textAlign: 'center' }}>
        <Button
          style={{ width: '75px', color: '#b40000', border: '1px solid #b40000', marginRight: '20px' }}
          size="sm"
          appearance={'ghost'}
          onClick={() => {
            if (!formRef.check()) {
              return;
            }
            Alert.success('Your feedback has been submitted!');
            // This feedback needs to be recorded somewhere
            setClose(false);
            handleSuccess();
          }}>
          Send
        </Button>
        <Button style={{ width: '75px' }} size="sm" appearance={'ghost'} onClick={() => setClose(false)}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

GetFeedback.propTypes = {
  show: PropTypes.bool.isRequired,
  setClose: PropTypes.func.isRequired,
};

export default GetFeedback;
